import {
  AppBar,
  Avatar,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MenuIcon from "@mui/icons-material/Menu";
import InfoIcon from "@mui/icons-material/Info";
import LogoutRoundedIcon from "@mui/icons-material/LogoutRounded";
import SelectLanguage from "../../../components/SelectLanguage";
import SelectPlant from "../../../components/SelectPlant";
import React, { useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import OperatorPDFTurkish from "../../../assets/operator_teknoktadersi.pdf";
import TechnicianPDFTurkish from "../../../assets/teknisyen_teknoktadersi.pdf";
import OperatorPDFEnglish from "../../../assets/operator_onepointlesson_ENG.pdf";
import TechnicianPDFEnglish from "../../../assets/technician_onepointlesson_ENG.pdf";
import { useOktaAuth } from "@okta/okta-react";
import { useTranslation } from "react-i18next";
import { appVersion } from "../../../utils/config";
import { saveAs } from "file-saver";
// Theme
import { useTheme } from "@mui/material/styles";
import { ThemeModeContext } from "../../../theme/ThemeModeContext";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";

const useStyles = makeStyles((theme) => ({
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(1),
  },
  title: {
    display: "none",
    [theme.breakpoints.up("xs")]: {
      display: "block",
    },
  },
  sectionDesktop: {
    display: "none",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

const avatarStyle = {
  width: 40,
  height: 40,
  color: "#000",
  backgroundColor: "#c8c8c8",
  border: "2px solid",
  borderColor: "#9c0404",
};

function Navbar(props) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [renderMobileScreen, setRenderMobileScreen] = useState(false);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const [loggedIn, setLoggedIn] = useState(null);
  const [userProfile, setUserProfile] = useState({
    preferred_username: "MOST@arcelik.com",
    name: "MOST",
  });
  const isMenuOpen = Boolean(anchorEl);
  const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);
  const { t } = useTranslation("translation");
  const { oktaAuth } = useOktaAuth();

  const theme = useTheme();
  const themeMode = React.useContext(ThemeModeContext);

  useEffect(() => {
    let oktaToken = JSON.parse(localStorage.getItem("okta-token-storage"));
    if (oktaToken && oktaToken.idToken) {
      setUserProfile(oktaToken.idToken.claims);
      setLoggedIn(true);
    } else {
      setLoggedIn(false);
    }
  }, []);

  function pdfContent(userRight) {
    if (userRight.length == 1 && userRight.includes("ProdOperator")) {
      if (localStorage.getItem("i18nextLng") == "tr-TR") {
        return OperatorPDFTurkish;
      }
      return OperatorPDFEnglish;
    } else {
      if (localStorage.getItem("i18nextLng") == "tr-TR") {
        return TechnicianPDFTurkish;
      }
      return TechnicianPDFEnglish;
    }
  }

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  const handleMobileMenuOpen = (event) => {
    setMobileMoreAnchorEl(event.currentTarget);
  };

  const handleLogin = async () => {
    handleMenuClose();
    oktaAuth.signInWithRedirect();
  };

  const routeProfile = () => {
    handleMenuClose();
    props.history.push("/profile");
  };

  const saveFile = () => {
    saveAs(pdfContent(props.userRight), "Information.pdf");
  };

  useEffect(() => {
    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        window.navigator.userAgent
      )
    ) {
      setRenderMobileScreen(true);
    } else {
      setRenderMobileScreen(false);
    }
  }, [window.navigator.userAgent]);

  const handleLogout = async () => {
    handleMenuClose();

    if (localStorage.getItem("ImpersonatedUser")) {
      localStorage.removeItem("ImpersonatedUser");
    }
    oktaAuth.signOut();
  };

  const menuItems = [
    {
      onClickFunction: routeProfile,
      text: t("Profile"),
      loggedIn: loggedIn,
    },
    {
      onClickFunction: handleLogout,
      text: t("SignOut"),
      loggedIn: loggedIn,
    },
    {
      onClickFunction: handleLogin,
      text: t("Login"),
      loggedIn: !loggedIn,
    },
  ];

  const menuId = "nb_Menu";
  const renderMenu = (
    <Menu
      id={menuId}
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <div>
        {menuItems.map((item, index) =>
          item.loggedIn ? (
            <MenuItem
              id={`nb_MenuItem_${index}`}
              onClick={item.onClickFunction}
              key={index}
            >
              {item.text}
            </MenuItem>
          ) : null
        )}
      </div>
    </Menu>
  );

  const menuItemsMobile = [
    {
      onClickFunction: null,
      component: <SelectPlant id="nb_Mobile_SelectPlant" />,
      text: t("Plant"),
    },
    {
      onClickFunction: null,
      component: <SelectLanguage id="nb_SelectLanguage" />,
      text: t("Language"),
    },
    {
      onClickFunction: () => saveFile(),
      component: (
        <IconButton
          id="nb_Mobile_IconButton"
          aria-label="info"
          aria-haspopup="true"
          color="inherit"
          size="large"
        >
          <InfoIcon />
        </IconButton>
      ),
      text: t("Information"),
    },
    {
      onClickFunction: routeProfile,
      component: (
        <IconButton
          id="nb_Mobile_IconButton_1"
          aria-label="account of current user"
          aria-controls="primary-search-account-menu"
          aria-haspopup="true"
          color="inherit"
          size="large"
        >
          <AccountCircle id="nb_Mobile_AccountCircle" />
        </IconButton>
      ),
      text: t("Profile"),
    },
    {
      onClickFunction: handleLogout,
      component: (
        <IconButton id="nb_Mobile_IconButton_2" color="inherit" size="large">
          <LogoutRoundedIcon id="nb_Mobile_LogoutIcon" />
        </IconButton>
      ),
      text: t("SignOut"),
    },
  ];

  const mobileMenuId = "nb_Mobile_Menu";
  const renderMobileMenu = (
    <Menu
      id={mobileMenuId}
      anchorEl={mobileMoreAnchorEl}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
      keepMounted
      transformOrigin={{ vertical: "top", horizontal: "right" }}
      open={isMobileMenuOpen}
      onClose={handleMobileMenuClose}
    >
      {menuItemsMobile.map((item, index) => (
        <MenuItem
          id={`nb_Mobile_MenuItem_${index}`}
          onClick={item.onClickFunction}
          key={index}
        >
          {item.component}
          {item.onClickFunction !== null ? <p>{item.text}</p> : null}
        </MenuItem>
      ))}
    </Menu>
  );

  const renderProfileItem = (onClickFunction) => (
    <Tooltip id="nb_Tooltip" title={t("Profile")}>
      <IconButton
        id="nb_IconButton_1"
        aria-label="account of current user"
        aria-controls={menuId}
        aria-haspopup="true"
        onClick={onClickFunction}
        color="inherit"
        size="large"
        disableRipple={true}
      >
        {localStorage.getItem("plantCode") ? (
          <Avatar id="nb_Avatar" sx={avatarStyle}>
            <Typography
              id="nb_Typography_1"
              variant="subtitle2"
              noWrap
              sx={{ fontSize: 17, marginTop: 0.05, letterSpacing: 1 }}
            >
              {JSON.parse(localStorage.getItem("plantCode"))}
            </Typography>
          </Avatar>
        ) : (
          <AccountCircle id="nb_AccountCircle" />
        )}
        <Typography id="nb_Typography_2" noWrap sx={{ marginLeft: 1 }}>
          {renderMobileScreen
            ? userProfile.preferred_username.split("@")[0]
            : userProfile.name}
        </Typography>
      </IconButton>
    </Tooltip>
  );

  return (
    <div className={classes.grow}>
      <AppBar id="nb_AppBar" position="static">
        <Toolbar id="nb_Toolbar">
          {/* Sidebar icon settings */}
          <IconButton
            id="nb_IconButton"
            edge="start"
            color="inherit"
            aria-label="open drawer"
            onClick={props.menuClick}
            size="large"
          >
            <MenuIcon id="nb_MenuIcon" />
          </IconButton>
          <Typography
            id="nb_Typography"
            component={Link}
            to="/"
            noWrap
            style={{ cursor: "pointer", textDecoration: "none" }}
          >
            <Grid container>
              <Grid item xs={9} sm={8} md={8}>
                <Button id="most_icon_btn">
                  <img src={"most_dark.png"} alt="MOST" width="90" />
                </Button>
              </Grid>
              <Grid
                id="version_grd"
                item
                xs={3}
                sm={4}
                md={4}
                style={{
                  display: "flex",
                  alignItems: "flex-end",
                  marginBottom: 5,
                }}
              >
                <label
                  id="version_lbl"
                  style={{ color: "#D3D3D3", fontSize: 8 }}
                >
                  {appVersion}
                </label>
              </Grid>
            </Grid>
          </Typography>
          <div className={classes.grow} />
          <div className={classes.sectionDesktop}>
            <Tooltip id="nb_Tooltip_0" title={t("ChangeTheme")}>
              <IconButton
                id="nb_IconButton_0"
                onClick={themeMode.toggleThemeMode}
                color="inherit"
                size="large"
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Tooltip>
            <SelectPlant id="nb_SelectPlant" />
            <SelectLanguage id="nb_SelectLanguage_1" />
            <Tooltip id="nb_Tooltip_1" title={t("Information")}>
              <IconButton
                id="nb_IconButton_2"
                aria-label="info"
                aria-controls={menuId}
                color="inherit"
                onClick={() => saveFile()}
                size="large"
              >
                <InfoIcon id="nb_InfoIcon" />
              </IconButton>
            </Tooltip>
            {renderProfileItem(handleProfileMenuOpen)}
          </div>
          <div className={classes.sectionMobile}>
            <Tooltip id="nb_Tooltip_2" title={t("ChangeTheme")}>
              <IconButton
                id="nb_IconButton_4"
                onClick={themeMode.toggleThemeMode}
                color="inherit"
                size="large"
              >
                {theme.palette.mode === "dark" ? (
                  <Brightness7Icon />
                ) : (
                  <Brightness4Icon />
                )}
              </IconButton>
            </Tooltip>
            {renderProfileItem(handleMobileMenuOpen)}
          </div>
        </Toolbar>
      </AppBar>
      {renderMobileScreen ? renderMobileMenu : renderMenu}
    </div>
  );
}

export default withRouter(Navbar);
